














import { Component, Prop, Vue } from 'vue-property-decorator'

import { OrderPayment, OrderPaymentStatus } from '@/models'

import { VuesaxColors } from '@/shims-vuesax'

@Component
export default class OrderPaymentStatusChip extends Vue {
  @Prop({ type: Object, required: true })
  readonly orderPayment!: OrderPayment

  OrderStatusColors: { [key in OrderPaymentStatus]: VuesaxColors } = {
    [OrderPaymentStatus.CANCELED]: 'danger',
    [OrderPaymentStatus.COMPLETED]: 'success',
    [OrderPaymentStatus.WAITING]: 'warning'
  }

  OrderStatusTexts: { [key in OrderPaymentStatus]: string } = {
    [OrderPaymentStatus.CANCELED]: 'Camcelado',
    [OrderPaymentStatus.COMPLETED]: 'Pago',
    [OrderPaymentStatus.WAITING]: 'Não Pago'
  }

  get statusColor () {
    return this.OrderStatusColors[this.orderPayment.status]
  }

  get statusText () {
    return this.OrderStatusTexts[this.orderPayment.status]
  }
}
